import { createFileRoute } from "@tanstack/react-router";
import { Login } from "@/app/login";
import { Logo } from "@/app/logo";
import { redirectToOrganization } from "@/lib/auth";
import { waitForClerk } from "@/lib/waitForClerk";

export const Route = createFileRoute("/login")({
	component: RouteComponent,
	beforeLoad: async ({ context, search }) => {
		await waitForClerk(context.clerk);
		await redirectToOrganization(context.clerk, search);
	},
});

function RouteComponent() {
	return (
		<div className="flex min-h-screen flex-col items-center justify-center bg-background py-4">
			<div className="flex flex-col items-center gap-6">
				<Logo className="h-10 mb-4" />
				<Login />
				<p className="max-w-md text-center text-xs text-muted-foreground">
					Looking for Rivet Enterprise Cloud? Visit{" "}
					<a
						href="https://hub.rivet.gg"
						className="underline"
						target="_blank"
						rel="noreferrer"
					>
						hub.rivet.gg
					</a>
				</p>
			</div>
		</div>
	);
}
